import React, { useState, createContext, ReactNode, useEffect } from 'react';
import { getNotificationsList } from '../services/NetworkServices';
import { getUnReadNotificationsCount } from '../services/NetworkServices';

const today = new Date();
const thisMonth = new Date();
thisMonth.setDate(1);

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  // console.log("day is", day);
  return `${year}-${month}-${day}`;
};

export interface BabysitterContextProps {
  totalRecords: number;
  currentPage: number;
  setCurrentPage: (value: number) => void;
  itemsPerPage: number;
  handleNextPage: (value: number) => void;
  handlePreviousPage: (value: number) => void;
  markAsRead: boolean;
  handleMarkAsRead: (value: boolean) => void;
  notificationsList: any[];
  handleNotificationsList: (value: any[]) => void;
  notificationsCount: number;
  handleNotificationsCount: (value: number) => void;
  selectedStartDate: Date | undefined | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | undefined | null>>;
  selectedEndDate: Date | undefined | null;
  setEndDate: React.Dispatch<React.SetStateAction<Date | undefined | null>>;
  handleStartDateChange: (date: Date) => void;
  handleEndDateChange: (date: Date) => void;
  payload: Payload;
  handlePayloadChange: (value: Payload) => void;
  formatDate: (date: Date) => string;
  checkInsList: any[];
  handleCheckInsList: (value: any[]) => void;
  showDatePicker: boolean;
  showDatePickerForDownload: boolean;
  handleShowDatePicker: (value: boolean) => void;
  handleShowDatePickerForDownload: (value: boolean) => void;
}

export interface Payload {
  startDate: string;
  endDate: string;
}

interface BabysitterProviderProps {
  children: ReactNode;
}

const BabysitterContext = createContext<BabysitterContextProps | undefined>(
  undefined,
);

const BabysitterProvider: React.FC<BabysitterProviderProps> = ({
  children,
}) => {
  const [payload, setPayload] = useState<Payload>({
    startDate: formatDate(thisMonth),
    endDate: formatDate(today),
  });

  // console.log("payload is", payload);

  const [checkInsList, setCheckInsList] = useState<any[]>([]);
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [showDatePickerForDownload, setShowDatePickerForDownload] =
    useState<boolean>(false);
  const [selectedStartDate, setStartDate] = useState<Date | undefined | null>();
  const [selectedEndDate, setEndDate] = useState<Date | undefined | null>();
  const [notificationsList, setNotificationsList] = useState<any[]>([]);
  const [notificationsCount, setNotificationsCount] = useState<number>(0);
  const [markAsRead, setMarkAsRead] = useState<boolean>(false);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 5;
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const handleNextPage = (value: number) => {
    setCurrentPage(value);
  };

  const handlePreviousPage = (value: number) => {
    if (currentPage > 1) {
      setCurrentPage(value);
    }
  };

  const handleCheckInsList = (value: any[]) => {
    setCheckInsList(value);
  };

  const handleNotificationsList = (value: any[]) => {
    setNotificationsList(value);
  };

  const handleMarkAsRead = (value: boolean) => {
    setMarkAsRead(value);
  };
  const handlePayloadChange = (value: Payload) => {
    setPayload(value);
  };

  const handleShowDatePicker = (value: boolean) => {
    setShowDatePicker(value);
  };

  const handleShowDatePickerForDownload = (value: boolean) => {
    setShowDatePickerForDownload(value);
  };

  const handleStartDateChange = (date: Date) => {
    setStartDate(date);
  };
  const handleEndDateChange = (date: Date) => {
    setEndDate(date);
  };

  useEffect(() => {
    const fetchNotificationsList = async () => {
      // Call API to fetch notifications list
      const response = await getNotificationsList(currentPage, itemsPerPage);
      const data = await response.data;
      if (data) {
        setTotalRecords(data.data.count);
        const filteredNotificationsListByDate = data.data.notifications.map(
          (notification: Notification) => ({
            date: notification.title,
            notifications: notification.data,
          }),
        );
        console.log(
          'filteredNotificationsListByDate',
          filteredNotificationsListByDate,
        );
        handleNotificationsList(filteredNotificationsListByDate);
      }
    };
    fetchNotificationsList();
  }, [currentPage]);

  useEffect(() => {
    const fetchUnReadNotificationsCount = async () => {
      const response = await getUnReadNotificationsCount();
      const data = await response.data;
      if (data) {
        setNotificationsCount(data.data.count);
      }
    };
    fetchUnReadNotificationsCount();
  });

  const handleNotificationsCount = (value: number) => {
    setNotificationsCount(value);
  };
  return (
    <BabysitterContext.Provider
      value={{
        totalRecords,
        handleNextPage,
        handlePreviousPage,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        markAsRead,
        handleMarkAsRead,
        notificationsCount,
        handleNotificationsCount,
        notificationsList,
        handleNotificationsList,
        selectedStartDate,
        setStartDate,
        selectedEndDate,
        setEndDate,
        handleStartDateChange,
        handleEndDateChange,
        showDatePicker,
        showDatePickerForDownload,
        handleShowDatePicker,
        handleShowDatePickerForDownload,
        payload,
        handlePayloadChange,
        formatDate,
        checkInsList,
        handleCheckInsList,
      }}
    >
      {children}
    </BabysitterContext.Provider>
  );
};

export { BabysitterContext, BabysitterProvider };
